/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Upload icon
 *
 * @file UploadIcon.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function UploadIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M21 12.9999C21.5523 12.9999 22 13.4476 22 13.9999V17.9999C22 20.209 20.2091 21.9999 18 21.9999H6C3.79089 21.9999 2.00004 20.209 2 17.9999V13.9999C2 13.4476 2.44772 12.9999 3 12.9999C3.55228 12.9999 4 13.4476 4 13.9999V17.9999C4.00004 19.1045 4.89546 19.9999 6 19.9999H18C19.1045 19.9999 20 19.1045 20 17.9999V13.9999C20 13.4476 20.4477 12.9999 21 12.9999Z"
        fill="currentColor"
      />
      <path
        d="M11.293 2.29289C11.6835 1.90237 12.3165 1.90237 12.707 2.29289L18.3643 7.94914C18.7547 8.33956 18.7544 8.97265 18.3643 9.36321C17.9737 9.75373 17.3407 9.75373 16.9502 9.36321L13 5.41301V15.9999C13 16.5522 12.5523 16.9999 12 16.9999C11.4477 16.9999 11 16.5522 11 15.9999V5.41399L7.05078 9.36418C6.66027 9.75466 6.02626 9.75466 5.63574 9.36418C5.24523 8.97367 5.24526 8.33967 5.63574 7.94914L11.293 2.29289Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default UploadIcon;
